import MetricsData, { OrdersData, PlatformData, HourlyOrderData, OrderStatusData, RevenueByFoodCourtData } from "types/dashboard/dashboardTypes";
import { apiClient } from "../client";

const authHeaders = () => ({
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
});

export const getKAPIs = async (): Promise<MetricsData> => {
    const response = await apiClient.get<MetricsData>(`/order/admin/orders/daily-kpis`, authHeaders());
    return response.data;
}

export const getOrderGrowth = async (): Promise<OrdersData> => {
    const response = await apiClient.get<OrdersData>(`/order/admin/orders/daily-order-growth`, authHeaders());
    return response.data;
}

export const getPlatformFeeGrowth = async (): Promise<PlatformData> => {
    const response = await apiClient.get<PlatformData>(`/order/admin/orders/platform-fee-growth`, authHeaders());
    return response.data;
}

// ── Analytics APIs ──

export const getHourlyDistribution = async (): Promise<HourlyOrderData[]> => {
    const response = await apiClient.get<HourlyOrderData[]>(`/order/admin/orders/hourly-distribution`, authHeaders());
    return response.data;
}

export const getOrderStatusBreakdown = async (): Promise<OrderStatusData[]> => {
    const response = await apiClient.get<OrderStatusData[]>(`/order/admin/orders/status-breakdown`, authHeaders());
    return response.data;
}

export const getRevenueByFoodCourt = async (): Promise<RevenueByFoodCourtData[]> => {
    const response = await apiClient.get<RevenueByFoodCourtData[]>(`/order/admin/orders/revenue-by-foodcourt`, authHeaders());
    return response.data;
}